﻿import { IEmailFamily } from './email-family';
import { IEmailType } from './email-type';
import { IEmailExcelId } from './email-excel-id';

export interface IEmailTag {
    id: number;
    emailTemplateId: number;
    emailFamily: IEmailFamily;
    emailType: IEmailType;
    emailExcelId: IEmailExcelId;
}
